<!-- navigation side menu for web view -->
<ion-content class="transact-menu-container content-web-section">
  <div class="transact-items-container">
    <ng-template ngFor let-item [ngForOf]="transactMenuItems">
      <div  *ngIf="!item.disabled" class="transact-item-wrap" (click)="setTransactActiveTab(item)">
        <div class="transact-item">
          <div class="transact-item-icon">
            <img src={{item.icon}}>
          </div>
          <div class="transact-item-text" [ngClass]="{'active' : activeTransactTab === item.activeTab}">
            {{item.displayName}}
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</ion-content>

<!-- navigation bottom drawer for mobile view -->
<ion-bottom-drawer class="content-mobile-section transact-drawer" [minimumHeight]=50 [dockedHeight]=350
  [shouldBounce]=true [distanceTop]=50>
  <div class="handle" (click)="closeMobileTransactMenu()"></div>
  <div class="transact-items-container">
    <div *ngFor="let item of transactMenuItems" class="transact-item-wrap" (click)="setTransactActiveTab(item)">
      <div [ngClass]="{'active-transact-highlight' : activeTransactTab === item.activeTab}"></div>
      <div class="transact-item">
        <div class="transact-item-icon">
          <img src={{item.icon}}>
        </div>
        <div class="transact-item-text" [ngClass]="{'active' : activeTransactTab === item.activeTab}">
          {{item.displayName}}
        </div>
      </div>
    </div>
  </div>
</ion-bottom-drawer>